import { render } from "./ArtistCard.vue?vue&type=template&id=1e41a0c4&scoped=true"
import script from "./ArtistCard.vue?vue&type=script&lang=js"
export * from "./ArtistCard.vue?vue&type=script&lang=js"

import "./ArtistCard.vue?vue&type=style&index=0&id=1e41a0c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e41a0c4"]])

export default __exports__